import { z } from 'zod';
export interface FeesDetails {
  feeSelection: string;
  discountCode: string;
}

export interface GdprDetails {
  gdprSelections: string;
}

export interface ClientDetails {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  nameOfPersonReceivingCare: string;
  contextAboutSituation: string;
}

export interface PartnerDetails {
  firstName: string;
  lastName: string;
  email: string;
  phoneNumber: string;
  partnerCode?: string;
  ltcLicense?: string;
}

export interface ReferralDetails {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  personReceivingCare: string;
  careSituationContext: string;
  discountCode: string;
  licenceCode?: string;
  feePaid: string;
  personalizedMsg: string;
  gdprSelections: string;
}

export interface ReferrerDetails {
  firstName: string;
  lastName: string;
  email: string;
  contactNumber: string;
  partnerCode: string;
  referLtcCode: string;
}

export interface Referral {
  referrer: Partial<ReferrerDetails>;
  referral: Partial<ReferralDetails>;
}

export interface ReferClientRequest {
  referrer: Partial<ReferrerDetails>;
  referral: Partial<ReferralDetails>;
  personalizedMsg?: string;
}

export const ReferralSubmissionResponseSchema = z.object({
  isExistingPartner: z.boolean(),
});

export type ReferralSubmissionResponse = z.infer<
  typeof ReferralSubmissionResponseSchema
>;
